export const placeholderMap = new Map<number, string>([
    [0, 'request_feedback.feedback_placeholder'],
    [1, 'request_feedback.feedback_placeholder_upset'],
    [2, 'request_feedback.feedback_placeholder_upset'],
    [3, 'request_feedback.feedback_placeholder_upset'],
    [4, 'request_feedback.feedback_placeholder_happy'],
    [5, 'request_feedback.feedback_placeholder_happy'],
]);